/** @format */
import { css } from 'styled-components';

import { StyledToggleFavouriteProps } from '@toucan/components/molecules/toggle-favourite/types';

const baseStyles = ({ isFavourite }: StyledToggleFavouriteProps) => css`
    .inner-heart {
        position: absolute;
        align-self: center;
        opacity: 0;
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            .inner-heart {
                opacity: 1;
                transition-property: opacity;
                transition-duration: var(--animations-default-duration);
                transition-timing-function: var(
                    --animations-default-timing-function
                );
            }
        }
    }

    .toggle-favourite-icon {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
    }

    .heart-outline {
        position: absolute;
        align-self: center;
        overflow: visible;
    }

    .heart-waves {
        opacity: 0;
        position: absolute;
        align-self: center;

        path {
            stroke-width: 2px;
            stroke: white;
            stroke-linecap: round;
        }
    }
`;

const favouritedStyles = css`
    @keyframes heartPulse {
        0% {
            transform: scale(1);
        }
        33% {
            transform: scale(0.75);
        }
        66% {
            transform: scale(1.25);
        }
        100% {
            transform: scale(1);
        }
    }

    @keyframes heartWaves {
        0% {
            opacity: 0;
            transform: scale(0);
        }
        50% {
            transform: scale(3);
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: scale(1.5);
        }
    }

    .heart-waves {
        animation: 0.7s ease-out 0s 1 heartWaves forwards;
    }

    .heart-outline,
    .inner-heart {
        animation: 0.5s ease-out 0s 1 heartPulse forwards;
        opacity: 1;
    }
`;

export const styles = (props: StyledToggleFavouriteProps) => css`
    ${baseStyles(props)}
    ${props.isFavourite && favouritedStyles}
`;
